import { useEffect } from 'react'
import { useSelector } from 'react-redux'

import { useCommentActions } from 'redux/actions/Comments'

import { ApplicationState } from 'redux/Stores/types'
import {
  selectCommentThreadsForAnalysis,
  selectCommentThreadsForKeyMetric,
  selectCommentThreadsForReportEdition,
  selectCommentThread
} from 'redux/selectors/Comments'
import { TAnalysis } from './Analyses'

export const useCommentThreads = (keyMetricId: string | undefined) => {
  return useSelector((state: ApplicationState) =>
    selectCommentThreadsForKeyMetric(state, keyMetricId)
  )
}

export const useCommentThreadsForReportEdition = (
  reportEditionId: string | undefined
) => {
  return useSelector((state: ApplicationState) =>
    selectCommentThreadsForReportEdition(state, reportEditionId)
  )
}

export const useCommentThread = (rootId: string) => {
  return useSelector((state: ApplicationState) =>
    selectCommentThread(state, rootId)
  )
}

export const useCommentThreadsForAnalysis = (
  analysisId: string | undefined
) => {
  return useSelector((state: ApplicationState) =>
    selectCommentThreadsForAnalysis(state, analysisId)
  )
}

/**
 * The comment threads on an analysis, refetched when a change-logged field
 * changes: status, responsible, follow-up date or the size of the selection.
 */
export const useAnalysisComments = (analysis: TAnalysis | null) => {
  const { tryGetAllCommentsByAnalysis } = useCommentActions()

  const threads = useCommentThreadsForAnalysis(analysis?.id)

  const id = analysis?.id ?? null
  const selectedObjectCount =
    analysis?.properties.filter((item) => item.selected).length ?? 0

  const refetch = () => {
    if (id) {
      tryGetAllCommentsByAnalysis(id)
    }
  }

  // Refetched when a change writes an auto comment; a rerun moves created_at.
  useEffect(() => {
    if (id) {
      tryGetAllCommentsByAnalysis(id)
    }
  }, [
    id,
    analysis?.created_at,
    analysis?.status,
    analysis?.responsible_account_id,
    analysis?.follow_up_date,
    selectedObjectCount,
    tryGetAllCommentsByAnalysis
  ])

  return { threads, refetch }
}
